import { Link } from "react-router-dom";

export default function PrivacyPage() {
  return (
    <div
      className="min-h-screen px-4 py-8"
      style={{
        background: "linear-gradient(160deg, #0d1f1f 0%, #1a2f2f 40%, #0f1a1a 100%)",
        fontFamily: "Noto Sans JP, sans-serif",
      }}
    >
      <div className="max-w-2xl mx-auto space-y-5">
        <h1 className="text-xl font-bold" style={{ color: "#f4e5c3", fontFamily: "Montserrat, sans-serif" }}>
          プライバシーポリシー
        </h1>
        <div
          className="rounded-2xl p-4 text-sm leading-relaxed space-y-3"
          style={{
            background: "rgba(212,175,55,0.06)",
            border: "1px solid rgba(212,175,55,0.22)",
            color: "rgba(244,229,195,0.88)",
          }}
        >
          <p>当店は、お名前・メールアドレス・パスワード・誕生日などの会員情報を会員管理目的で取得します。</p>
          <p>取得した情報は、会員サービスの提供、本人確認、サポート対応、不正利用防止のために利用します。</p>
          <p>法令に基づく場合を除き、本人同意なく第三者へ個人情報を提供しません。</p>
          <p>本人からの照会・訂正・削除の申し出に、法令に従って対応します。</p>
        </div>
        <Link to="/register" className="text-xs underline" style={{ color: "rgba(212,175,55,0.9)" }}>
          登録画面へ戻る
        </Link>
      </div>
    </div>
  );
}
